const riot = require('riot');
import '../components/reports.tag'
riot.tag2('page-reports', '<reports></reports>', '', '', function(opts) {
});
